import React, {useEffect} from 'react';
import './about.scss';
import {Footer, Navigation} from "../../components";
import AboutHero from "./sections/about-hero/AboutHero";
import Values from "./sections/values/Values";
import HowDoWeHelp from "./sections/how-do-we-help/HowDoWeHelp";
import OurHistory from "./sections/our-history/OurHistory";
import HeroInfo from './sections/hero-info/HeroInfo';
import Board from "./sections/board/Board";

const About = () => {
    useEffect(() => {
        window.scrollTo(0, 0);

    }, []);
    return (
        <div className={'about'}>
            <div className="about_nav">
                <Navigation/>
            </div>
            <AboutHero/>
            <HeroInfo/>
            <Values/>
            <HowDoWeHelp/>
            <OurHistory/>
            <Board/>
            <Footer/>
        </div>
    );
};

export default About;
